import React from "react";
import { createRoot } from "react-dom/client";
import "./index.css";
import App from "./App";
import registerServiceWorker from "./registerServiceWorker";
import { Provider } from "react-redux";
import store from "./redux/store";

function initHtmlLayoutClass() {
  const params = new URLSearchParams(window.location.search);
  const layoutParam = params.get("app_layout");
  const themeParam = params.get("theme") || params.get("app_theme");

  // Keep parity with App.js so the background color is correct before React mounts.
  if (themeParam) {
    localStorage.setItem("app_theme", themeParam);
  }

  if (layoutParam) {
    let resolvedLayout = layoutParam;
    const resolvedTheme = themeParam || localStorage.getItem("app_theme");

    if (
      resolvedTheme === "dark" &&
      resolvedLayout &&
      resolvedLayout.startsWith("chef_house") &&
      !resolvedLayout.endsWith("_dark")
    ) {
      resolvedLayout = `${resolvedLayout}_dark`;
    }

    localStorage.setItem("app_layout", resolvedLayout);
  }

  const appLayout = localStorage.getItem("app_layout");
  if (!appLayout) return;

  // Only manage the Chef House family here (to avoid interfering with other layouts).
  document.documentElement.classList.remove(
    "chef_house",
    "chef_house_vertical",
    "chef_house_dark",
    "chef_house_vertical_dark"
  );

  if (appLayout.startsWith("chef_house")) {
    document.documentElement.classList.add(appLayout);
  }
}

initHtmlLayoutClass();

const root = createRoot(document.getElementById("root"));
root.render(
  <Provider store={store}>
    <App />
  </Provider>
);
registerServiceWorker();
